import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const DNO_BOUNDARIES: Layer = {
  id: "power_dno_boundaries",
  layerType: ConstraintsLayerType,
  group: LayerGroup.POWER,
  title: "DNO Boundaries",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  toggleable: true,
  description: "Operation areas for DNOs",
  icon: "lt-layer-dno-boundaries",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 6,
  },
  layerConfig: {
    minZoom: 6,
    rootCategory: ConstraintsCategory.DNO_BOUNDARIES,
    categorySchema: [{ key: "power_dno_boundaries" }],
  },
};
